// src/services/journalService.js

import { R1_EXERCISES } from '../data/exercises/R1_exercises';

/**
 * Danh sách ID của các bài 仕訳練習 (đảm bảo đúng thứ tự bạn muốn).
 * Nếu sau này thêm R1-31, R1-32... thì thêm vào đây.
 */
const JOURNAL_IDS = [
  'R1-01', 'R1-02', 'R1-03', 'R1-04', 'R1-05',
  'R1-06', 'R1-07', 'R1-08', 'R1-09', 'R1-10',
  'R1-11', 'R1-12', 'R1-13', 'R1-14', 'R1-15',
  'R1-16', 'R1-17', 'R1-18', 'R1-19', 'R1-20',
  'R1-21', 'R1-22', 'R1-23', 'R1-24', 'R1-25',
  'R1-26', 'R1-27', 'R1-28', 'R1-29', 'R1-30',
];

/**
 * Lấy danh sách bài 仕訳練習.
 * Trả về mảng: [{ id, title, questions, ... }]
 */
export const getJournalPracticeList = () => {
  return JOURNAL_IDS
    .map((id) => {
      const ex = R1_EXERCISES[id];
      if (!ex) return null;
      return {
        id,
        title: ex.title || id,
        ...ex,
      };
    })
    .filter(Boolean);
};

/**
 * Lấy chi tiết 1 bài 仕訳練習 theo id (vd: "R1-01")
 */
export const getJournalExerciseById = (exerciseId) => {
  return R1_EXERCISES[exerciseId] || null;
};
